import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Partners from "@/components/landing/Partners";
import Stats from "@/components/landing/Stats";
import FAQ from "@/components/landing/FAQ";
import ChatWidget from "@/components/landing/ChatWidget";
import Chapters from "@/components/landing/Chapters";
import Services from "@/components/landing/Services";
import Leistungsbereiche from "@/components/landing/Leistungsbereiche";
import Closing from "@/components/landing/Closing";
import LandingPage from "@/components/landing/LandingPage";
import { SEO_PAGES } from "@/components/landing/seoPages";
import Audience from "@/components/landing/Audience";
import Footer from "@/components/landing/Footer";
import ImageBand from "@/components/landing/NightBand";
import Connect from "@/components/landing/Connect";
import Referenzen from "@/components/landing/Referenzen";
import Reviews from "@/components/landing/Reviews";
import Admin from "@/components/landing/Admin";
import Impressum from "@/components/landing/Impressum";
import Datenschutz from "@/components/landing/Datenschutz";
import Team from "@/components/landing/Team";
import TeamProfile from "@/components/landing/TeamProfile";
import Portal from "@/components/landing/Portal";
import axios from "axios";

function Landing() {
  useEffect(() => {
    document.title = "Drohnen-Inspektion & RTK-Vermessung | DROPS TFR Drohnenservice";
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/visit`).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#09090B] text-white selection:bg-[#F5B301] selection:text-black">
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Partners />
        <Marquee />
        <Stats />
        <Leistungsbereiche />
        <Chapters />
        <Services />
        <ImageBand
          src="/assets/night-tower.jpg"
          alt="Funkmast bei Nacht aus der Luft aufgenommen"
          caption="NACHTLAGE // FUNKMAST-INSPEKTION"
          tag="DROPS TFR // AUFNAHME 05"
          testid="night-band"
          slot="band"
        />
        <Audience />
        <Connect />
        <Referenzen />
        <Reviews />
        <FAQ />
        <ImageBand
          src="/assets/radio-tower.jpg"
          alt="Funkmast und weitläufige Landschaft aus der Luft bei Tag"
          caption="TAGESLAGE // GEBIETSAUFKLÄRUNG"
          tag="DROPS TFR // AUFNAHME 06"
          testid="day-band"
          slot="band-2"
        />
        <Closing />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        {Object.keys(SEO_PAGES).map((slug) => (
          <Route key={slug} path={SEO_PAGES[slug].path} element={<LandingPage slug={slug} />} />
        ))}
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/team" element={<Team />} />
        <Route path="/team/:id" element={<TeamProfile />} />
        <Route path="/portal" element={<Portal />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster theme="dark" position="bottom-right" />
    </BrowserRouter>
  );
}
